// extracted by mini-css-extract-plugin
export default {"whiteBlock":"whiteWrapper_whiteBlock__Mi3l7","closeWrapper":"whiteWrapper_closeWrapper__48A-0"};